<template>
<div class="container-fluid Profile">

<div class="Header">
    Do you want to upload your data?   <input type="radio" id="Yes" name="dataUploadValue" value="Yes">
  <label for="Yes">Yes</label>
  <input type="radio" id="No" name="dataUploadValue" value="No">
  <label for="No">No</label>
</div>
<br>
<div>
<p>Click on the "Choose File" button to upload a file:</p>

<form action="/submit">
  <input type="file" id="myFile" name="filename">  <input type="submit" name="Upload Data" value="Upload Data">
</form>
</div>
<div class="router-view2">
    <!-- <DataDashboard/> -->
</div>
</div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
// import DataDashboard from 'DataDashboard.vue'
export default {
  created () {

  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.card1 {
    background-color: rgb(246, 249, 250);
}

.Header{
    background-color: lightblue;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    border-radius: 5px;
}

.router-view2 {
  width: 95%;
  height: 60%;
  border: 2px solid rgb(29, 28, 28);
  padding: 5% 15% 22% 20%;
}
</style>
